
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBh0WV9Xvk6_Jwqirx7jyicse_QamGPI40",
  authDomain: "company-webiste.firebaseapp.com",
  projectId: "company-webiste",
  storageBucket: "company-webiste.firebasestorage.app",
  messagingSenderId: "770521738457",
  appId: "1:770521738457:web:627f86b7e393f1681722c8",
  measurementId: "G-3C437R4RSL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
